export default [{
	path: '/:amp?/blog',
	component: () => import(/* webpackChunkName: 'Blog' */ './BlogHome.vue'),
	props: true,
	children: [
		{
			path: '/',
			name: 'blog',
			component: () => import(/* webpackChunkName: 'Blog' */ './BlogIndex.vue'),
			props: true
		},
		{
			path: 'page/:page?',
			name: 'blog-pagination',
			component: () => import(/* webpackChunkName: 'Blog' */ './BlogIndex.vue'),
			props: (route) => {
				const page = Number.parseInt(route.params.page, 10);
				if (Number.isNaN(page)) {
					return 0;
				}
				return { ...route.params, page };
			}
		},
		{
			path: 'tags/:tag',
			name: 'blog-tag',
			component: () => import(/* webpackChunkName: 'Blog' */ './BlogIndex.vue'),
			props: true
		},
		{
			path: 'tags/:tag?/page/:page?',
			name: 'blog-tag-pagination',
			component: () => import(/* webpackChunkName: 'Blog' */ './BlogIndex.vue'),
			props: true
		},
		{
			path: ':cfid/*',
			name: 'blog-article',
			component: () => import(/* webpackChunkName: 'Blog' */ './BlogIndex.vue'),
			props: true
		},
		{ path: '*', redirect: '/blog' }
	]
}];